/**
 * Created by Andrew on 01/03/2017.
 */

import React, { Component } from "react";
import EditCluster from "../presentation/EditCluster";
import validator from "validator";

class EditClusterWidget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      devices: [],
      cluster: [],
      selectedDevices: [],
      clusterDevice: [],
      clusterName: "",
      clusterComments: "",
      clusterId: this.props.pageParameters[0],
      errorField: "",
      success: "",
      error: "",
      search: "",
      sort: "name",
      sortAsc: "true",
      sortDevices: "name",
      sortDevicesAsc: "true",
      currentCluster: ""
    };
  }

  componentDidMount() {
    this.getClusterDetails();
  }

  updateFormState = e => {
    let obj = {};
    obj[e.target.name] = e.target.value;
    this.setState(obj);
  };

  validateInput = () => {
    if (this.state.clusterName === "") {
      this.setState({
        error: "Please enter a cluster name",
        errorField: "clusterName"
      });
    } else if (this.state.selectedDevices.length == 0) {
      this.setState({
        error: "Please select at least one device",
        errorField: "selectedDevices"
      });
    } else {
      this.setState({ error: false });
      return true;
    }
  };

  handleSubmit = () => {
    let devices = [];
    let selectedDevices = this.state.selectedDevices;
    if (selectedDevices.length) {
      selectedDevices.map(selectedDevice => {
        return devices.push(selectedDevice._id);
      });
    }

    var body = {
      name: this.state.clusterName,
      comments: this.state.clusterComments,
      devices: devices,
      _id: this.state.clusterId
    };

    this.setState({ serverError: "", success: "" });

    if (this.validateInput()) {
      fetch("/service/editCluster", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        credentials: "same-origin",
        body: JSON.stringify(body)
      }).then(response => {
        if (response.status != 200) {
          response.json().then(json => {
            this.setState({ serverError: "Error saving cluster" });
          });
        } else {
          response.json().then(json => {
            this.setState({ success: "Cluster has been updated successfully" });
            this.props.navigator.requestClusterManagement();
          });
        }
      });
    }
  };

  getClusterDetails = () => {
    fetch(
      "/service/handleGetClusterDetails?clusterId=" + this.state.clusterId,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        credentials: "same-origin"
      }
    ).then(response => {
      if (response.status === 200) {
        response.json().then(cluster => {
          this.setState(
            {
              clusterName: cluster.name,
              clusterComments: cluster.comments,
              clusterDevices: cluster.devices
            },
            () => {
              this.getClusterDevices();
            }
          );
        });
      }
    });
  };

  getClusterDevices = () => {
    fetch(
      "/service/getClusterDevices?devices=" +
        this.state.clusterDevices +
        "&sortDevices=" +
        this.state.sortDevices +
        "&sortDevicesAsc=" +
        this.state.sortDevicesAsc,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        credentials: "same-origin"
      }
    ).then(response => {
      if (response.status === 200) {
        response.json().then(selectedDevices => {
          this.setState({ selectedDevices }, () => {
            this.getDeviceList();
          });
        });
      }
    });
  };

  getDeviceList = () => {
    fetch(
      "/service/devices?search=" +
        this.state.search +
        "&sort=" +
        this.state.sort +
        "&sortAsc=" +
        this.state.sortAsc +
        "&registeredOnly=true",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        credentials: "same-origin"
      }
    ).then(response => {
      if (response.status === 200) {
        response.json().then(devices => {
          let selectedDevices = this.state.selectedDevices;
          if (selectedDevices.length) {
            let result = "";

            selectedDevices.map(selectedDevice => {
              result = devices.find(
                device => device._id === selectedDevice._id
              );

              if (result) {
                devices.splice(devices.indexOf(result), 1);
              }
            });
          }
          this.setState({ devices });
        });
      }
    });
  };

  updateClusterDevice = deviceId => {
    let selectedDevice = this.state.devices.find(device => {
      return device._id === deviceId;
    });
    let devices = this.state.devices;
    devices.splice(devices.indexOf(selectedDevice), 1);
    let selectedDevices = this.state.selectedDevices;
    selectedDevices.push(selectedDevice);
    this.setState({ selectedDevices: selectedDevices, devices: devices });
  };

  removeDevice = deviceId => {
    let device = this.state.selectedDevices.find(selectedDevice => {
      return selectedDevice._id === deviceId;
    });
    let selectedDevices = this.state.selectedDevices;
    selectedDevices.splice(selectedDevices.indexOf(device), 1);
    let devices = this.state.devices;
    devices.push(device);
    this.setState({ selectedDevices: selectedDevices, devices: devices });
  };

  updateSearchState = e => {
    this.setState({ search: e.target.value }, () => {
      this.getDeviceList();
    });
  };

  updateSortState = sortBy => {
    this.setState(prevState => {
      return sortBy === prevState.sort
        ? { sortAsc: !prevState.sortAsc }
        : { sort: sortBy };
    }, this.getDeviceList);
  };

  updateDevicesSortState = sortBy => {
    this.setState(
      prevState => {
        return sortBy === prevState.sortDevices
          ? { sortDevicesAsc: !prevState.sortDevicesAsc }
          : { sortDevices: sortBy };
      },
      () => {
        this.getClusterDevices(this.state.currentCluster, false);
      }
    );
  };

  deleteCluster = clusterId => {
    if (confirm("Are you sure you want to delete this cluster?")) {
      fetch("/service/deleteCluster", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        credentials: "same-origin",
        body: JSON.stringify({ clusterId: clusterId })
      }).then(response => {
        if (response.status !== 200) {
          this.setState({
            serverError: "Error! Cluster could not be deleted"
          });
        } else {
          response.json().then(json => {
            alert(
              "Cluster  " + json.cluster.name + " has been deleted successfully"
            );
            this.props.navigator.requestClusterManagement();
          });
        }
      });
    }
  };

  render() {
    return (
      <EditCluster
        navigator={this.props.navigator}
        handleSubmit={this.handleSubmit}
        updateFormState={this.updateFormState}
        loadData={this.state}
        deleteCluster={this.deleteCluster}
        updateClusterDevice={this.updateClusterDevice}
        removeDevice={this.removeDevice}
        updateSearchState={this.updateSearchState}
        updateSortState={this.updateSortState}
        updateDevicesSortState={this.updateDevicesSortState}
      />
    );
  }
}

export default EditClusterWidget;
